/**
 * Shared slug utilities. Mirror of backend/prediction_market/utils/slug.py.
 * Keep in sync — both sides must produce the same slug for the same title.
 */

export const slugify = (text, maxLen = 80) => {
  if (!text) return 'market';
  const s = text
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')      // strip accents
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, maxLen)
    .replace(/-+$/, '');
  return s || 'market';
};

// Public-facing SEO categories — same 5 keys as scripts/seo-content.cjs.
const SEO_TO_BACKEND = {
  politics: 'world_events',
  sports: 'sports',
  technology: 'tech',
  economics: 'finance',
  'world-events': 'world_events',
};

const BACKEND_TO_SEO = {
  world_events: 'world-events',
  sports: 'sports',
  tech: 'technology',
  finance: 'economics',
};

export const categoryToSeoSlug = (backendKey) => {
  if (!backendKey) return 'world-events';
  const k = String(backendKey).toLowerCase();
  return BACKEND_TO_SEO[k] || k.replace(/_/g, '-');
};

export const seoSlugToCategory = (seoSlug) => {
  if (!seoSlug) return null;
  return SEO_TO_BACKEND[String(seoSlug).toLowerCase()] || null;
};

export const marketCleanUrl = (market) => {
  if (!market) return '/';
  const cat = categoryToSeoSlug(market.category);
  const slug = slugify(market.title);
  return `/markets/${cat}/${slug}`;
};
